import { z } from "zod";

export const updatePublishedAt = {
  input: z.object({ formId: z.string(), publishedAt: z.date() }),
  output: z.literal("success"),
};
